import { AxiosError } from "axios";
import { GraphQLErrorExtensions } from "graphql/index";
import { ClientError } from "graphql-request";
import isNil from "lodash/isNil";
import isObject from "lodash/isObject";

export const getErrorBody = <T>(error: any): T | null => {
  if (isNil(error) || !isObject(error) || !("response" in error)) {
    return null;
  }

  if (error instanceof ClientError) {
    return (
      (
        error.response.errors?.[0].extensions as GraphQLErrorExtensions as {
          response: { body: T };
        }
      ).response?.body ?? null
    );
  }

  if (error instanceof AxiosError) {
    return error.response?.data;
  }

  return null;
};
